import { ReactComponent as WalletIcon } from '../icons/wallet.svg';
import { useState, useEffect } from 'react';
import { APIloader, Loader } from '../Commons';
import { useLoaderData } from 'react-router-dom';
import { DataProvider } from '../components/DataProvider';
import { DateSelect, ActiveCampaigns, ClicksChart, PerformanceChart, ContactUS, ChangeCampaignStatus } from '../components/Dashboards';
import { Link } from 'react-router-dom';

const numbers = new Intl.NumberFormat('he-IL', {
  maximumFractionDigits: 2
});

const ClientDashboard = () => {
  let thisMonth = new Date().getMonth() + 1;

  const [campaignData, setCampaignData] = useState(null);
  const [dateRange, setDateRange] = useState({period: 'monthly', value: thisMonth, key: 3}); // default date range
  const [sumPeriodClicks, setSumPeriodClicks] = useState(0);
  const [activeCampaigns, setActiveCampaigns] = useState(0);
  const [totalCampaigns, setTotalCampaigns] = useState(0);
  const [request, setRequest] = useState({request: null, params: null});

  const handleCampaignsChange = (data) => {
    let active = 0;
    data.forEach((campaign) => {
      if(campaign.active)
        active++
    });
    
    setActiveCampaigns(active);
    setTotalCampaigns(data.length);
  }

  useEffect(() => {
    // build request for DataProvider
    const params = {clicks: dateRange.period, value: dateRange.value};
    const req = new Request('/client/clicks');
    setRequest({request: req, params: params});
  }, [dateRange]);

  return (
    <>
      <DataProvider request={request.request} params={request.params}>
        <div className='grid grid-cols-2 grid-rows-4 gap-2 lg:grid-rows-2 lg:grid-cols-6 lg:gap-4 sm:grid-rows-3 sm:grid-cols-3'>
          <div className='content-center bg-blue-50 rounded-lg row-start-3 2xl:col-span-1 lg:row-start-1 lg:col-span-2 md:row-start-3 md:col-span-1 h-full'>
            <ClicksChart formatter={numbers} dateRange={dateRange} setSumPeriodClicks={setSumPeriodClicks} />
          </div>
          {/*<div className='content-center bg-lime-50 rounded-lg row-start-3 2xl:col-span-1 lg:col-span-2 lg:row-start-2 md:row-start-3 md:col-span-1 h-48'>
            <IncomeChart dateRange={dateRange} sumClicks={sumPeriodClicks} />
          </div>*/}
          <div className='content-center bg-purple-50 rounded-lg row-start-4 col-span-2 2xl:row-start-2 2xl:col-span-1 lg:col-span-2 sm:col-span-1 sm:row-start-3 h-full'>
            <ActiveCampaigns formatter={numbers} active={activeCampaigns} total={totalCampaigns} dateRange={dateRange} />
          </div>
          <div className='relative col-span-2 row-start-1 2xl:col-span-5 lg:col-span-4 lg:row-span-2 sm:col-span-3 bg-blue-50 rounded-lg'>
            <div className='flex justify-end gap-2 absolute left-2 top-2'>
              {/*<ExcelExport range={dateRange} />*/}
              <DateSelect range={dateRange} setRange={setDateRange} />
            </div>
            <div className='h-[28rem] overflow-hidden'>
              <PerformanceChart dateRange={dateRange} />
            </div>
          </div>
        </div>
      </DataProvider>
    
      <ContactUS campaign={campaignData} setCampaign={setCampaignData} />

      <div className='mt-8'>
        <div className='flex'>
          <h1 className='font-bold text-3xl leading-loose'>קמפיינים</h1>
          <div>
            {/* TODO: add search input, and filter based on active status */}
          </div>
        </div>
        <CampaignList setCampaignData={setCampaignData} onCampaignsChange={handleCampaignsChange} dateRange={dateRange} />
      </div>
    </>
  );
}

const ExcelExport = ({range}) => {
  const token = sessionStorage.getItem('accessToken');

  return (
    <a href={`https://${process.env.REACT_APP_API_ENDPOINT}/api.php?method=publisher&export=${range.period}&value=${range.value}&token=${token}`} target='_blank' rel='noreferrer' className='flex gap-2 items-center bg-white px-4 py-2 w-fit z-10 rounded bg-white drop-shadow'>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke='currentColor' className="h-6 w-6 text-green-400">
        <path d="M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M12.9 14.5L15.8 19H14L12 15.6L10 19H8.2L11.1 14.5L8.2 10H10L12 13.4L14 10H15.8L12.9 14.5Z" />
      </svg>
      ייצוא ל-Excel
    </a>
  )
}

const IncomeChart = ({sumClicks, dateRange}) => {
  const data = useLoaderData();

  let legend;
  if(dateRange.period === 'yearly')
    legend = 'בשנת ' + dateRange.value;
  else if(dateRange.period === 'monthly') {
    const monthName = new Intl.DateTimeFormat('he-IL', {month: 'long'}).format(new Date(new Date().getFullYear(), dateRange.value - 1));
    legend = 'בחודש ' + monthName;
  } else
    legend = 'ב-' + dateRange.value + ' ימים אחרונים';

  return (
    <section className="px-2 sm:px-4">
      <div className='flex flex-col gap-3 sm:flex-row'>
        <div className='bg-primary my-auto p-3 rounded-xl flex gap-2 text-white'>
          <WalletIcon />
          <span className='sm:hidden'>הכנסות</span>
        </div>
        <div className='px-2 sm:px-0'>
          <p className="hidden sm:block text-md">הכנסות</p>
          <p className="text-2xl md:text-3xl">₪{numbers.format(sumClicks * data.PPC)}</p>
          <p className="text-sm text-gray-500 sm:text-xs">{legend}</p>
        </div>
      </div>
    </section>
  )
}

const CampaignList = ({ setCampaignData, onCampaignsChange, dateRange }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [dialog, setDialog] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const request = new Request('/client/campaigns');
        const params = {view: dateRange.period, value: dateRange.value};
        const result = await APIloader(request, params);
        setData(result);
      } catch (err) {
        // do nothing for now
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [dateRange]);

  useEffect(() => {
    onCampaignsChange(data);
  }, [data, onCampaignsChange]);

  // TODO:
  // add search input, and filter based on active status
  // add pagination

  const rows = data.map((campaign, index) => {
    const usedBudget = campaign.sumClicks * campaign.priceCPC;
    return (
      <tr className='bg-blue-50 rounded-lg' key={index}>
        <td>{campaign.name}</td>
        <td>{campaign.startDate}</td>
        <td>{campaign.endDate}</td>
        <td>{numbers.format(campaign.sumClicks)}</td>
        <td>₪{numbers.format(campaign.priceCPC)}</td>
        <td>₪{numbers.format(campaign.price)}</td>
        <td>₪{numbers.format(usedBudget)}</td>
        <td>
          {campaign.active ? (
            <span
              onDoubleClick={() => setDialog(campaign)}
              className="cursor-pointer inline-flex items-center justify-center rounded border border-emerald-700 px-2.5 py-0.5 text-emerald-700 bg-white text-sm"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="-ms-1 me-1 size-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <p>פעיל</p>
            </span>
          ) : (
            <span className="cursor-pointer inline-flex items-center justify-center rounded border border-red-700 px-2.5 py-0.5 text-red-700 bg-white text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="-ms-1 me-1 size-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
              </svg>
              <p>כבוי</p>
            </span>
          )}
        </td>
        <td className="whitespace-nowrap px-4 flex gap-2">
          <button
            className="rounded-lg bg-primary py-2 px-4 text-sm text-white transition hover:scale-110 hover:shadow-xl focus:outline-none focus:ring active:bg-indigo-500"
            onClick={() => setCampaignData(campaign)}
          >
            פניה לניהול
          </button>
          <Link className='rounded-lg bg-primary py-2 px-4 text-sm text-white transition hover:scale-110 hover:shadow-xl focus:outline-none focus:ring active:bg-indigo-500' to={`https://${process.env.REACT_APP_API_ENDPOINT}/viewQuote/index.html?id=${campaign.priceQuoteId}&key=${campaign.secret}`} target='_blank'>הצעת מחיר</Link>
        </td>
      </tr>
    );
  });

  if(loading)
    return <Loader />;

  if(rows.length === 0 || data.errors)
    return <p className='text-xl text-center'>אין מידע זמין להצגה</p>;

  return (
    <>
    <table className="min-w-full divide-y-8 divide-transparent text-sm">
      <thead className="text-right">
        <tr>
          <th>שם הקמפיין</th>
          <th>התחלת פרסום</th>
          <th>סיום פרסום</th>
          <th>הקלקות</th>
          <th>מחיר לקליק (CPC)</th>
          <th>תקציב</th>
          <th>תקציב מנוצל</th>
          <th>סטטוס</th>
          <th></th>
        </tr>
      </thead>
      <tbody className="divide-y-2 divide-white">
        {rows}
      </tbody>
    </table>
    {dialog && <ChangeCampaignStatus campaign={dialog} display={setDialog} setCampaigns={setData} />}
    </>
  );
}

export default ClientDashboard;